import React from 'react';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { IResortPageSnowInfo } from 'api/resort/types';
import classNames from 'classnames';
import { OpenStatus } from 'components/blocks/OpenStatus';
import { SHORT_DATE_FORMAT, formatDateFromStr } from 'util/formatDate';
import styles from './styles.module.scss';

export const ResortStatus = ({ fullResort }: { fullResort: IResortPageSnowInfo }) => {
  const { t } = useOTSTranslation('common');

  return (
    <div className={classNames(styles.box)}>
      <span className={classNames('h2')}>
        {fullResort.title}
        :&nbsp;
        <OpenStatus flag={fullResort.status.openFlag} />
      </span>
      <time className={styles.updatedAt}>
        {t('resort.skiReport.lastUpdated')}
      &nbsp;
        {formatDateFromStr(fullResort.updatedAt, SHORT_DATE_FORMAT)}
      </time>
    </div>
  );
};
